import React, { useEffect, useRef, useState } from "react";
import { Btn, Modal } from "@/components/erp/ui";
import { toast } from "sonner";

// Kamera langsung (tidak bisa pilih dari galeri). onShot menerima Blob jpeg.
export const LiveCamera = ({ title, onShot, onClose }) => {
  const vid = useRef(null); const [stream, setStream] = useState(null); const [fail, setFail] = useState("");
  useEffect(() => {
    let s;
    navigator.mediaDevices?.getUserMedia({ video: { facingMode: "user", width: { ideal: 1280 } }, audio: false })
      .then((x) => { s = x; setStream(x); if (vid.current) { vid.current.srcObject = x; vid.current.play().catch(() => {}); } })
      .catch(() => setFail("Kamera tidak bisa dibuka — izinkan akses kamera di browser / HP"));
    return () => { s?.getTracks().forEach((t) => t.stop()); };
  }, []);
  const shoot = () => {
    const v = vid.current; if (!v?.videoWidth) { toast.error("Kamera belum siap"); return; }
    const c = document.createElement("canvas"); c.width = v.videoWidth; c.height = v.videoHeight;
    c.getContext("2d").drawImage(v, 0, 0);
    c.toBlob((b) => { stream?.getTracks().forEach((t) => t.stop()); onShot(b); }, "image/jpeg", 0.9);
  };
  return (
    <Modal open onClose={onClose} title={title} footer={<><Btn variant="ghost" onClick={onClose}>Batal</Btn><Btn data-testid="live-cam-shoot" disabled={!stream} onClick={shoot}>Ambil foto</Btn></>}>
      {fail ? <p className="text-sm text-rose-600" data-testid="live-cam-error">{fail}</p>
        : <video ref={vid} playsInline muted className="w-full rounded-lg bg-black aspect-[4/3] object-cover -scale-x-100" data-testid="live-cam-video" />}
      <p className="text-[11px] text-slate-500 mt-2">Foto diambil langsung dari kamera — tidak bisa memakai foto dari galeri. GPS wajib aktif.</p>
    </Modal>
  );
};
